<template>
  <label v-bind="$attrs" class="d-block text-start ps-3">
    <slot></slot>
  </label>
</template>
